import React from 'react';
import { MoneyHandIcon, MoneyOffIcon, CalendarClockIcon, LocalOfferIcon } from '../../icons';

const ICONS = {
    'money_hand': MoneyHandIcon,
    'money_off': MoneyOffIcon,
    'calendar_clock': CalendarClockIcon,
    'local_offer': LocalOfferIcon,
};

const PROPOSITIONS = [
    { key: 'fast-funding', icon: 'money_hand', text: 'Cash deposited as fast as today' },
    { key: 'no-hidden-fees', icon: 'money_off', text: 'No hidden fees' },
    { key: 'no-prepayment-penalty', icon: 'calendar_clock', text: 'No early payoff penalties' },
    { key: 'autopay-discount', icon: 'local_offer', text: 'Autopay discount' },
];

const OffersV4ValueProps = () => (
    <div className="offers-v4-trust-signals">
        <div className="offers-v4-value-props">
            <div className="offers-v4-value-props__list">
                {PROPOSITIONS.map(prop => {
                    const IconComponent = ICONS[prop.icon];
                    return (
                        <div className="offers-v4-value-props__list-item" key={prop.key}>
                            <div className="offers-v4-value-props__list-item-icon">
                                <div className="offers-v4-value-props__list-item-icon-wrapper">
                                    <IconComponent />
                                </div>
                            </div>
                            <div className="offers-v4-value-props__list-item-content">
                                <span className="offers-v4-value-props__text">{prop.text}</span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    </div>
);

export default OffersV4ValueProps;
